import { api } from "@api/index";
import ConditionalErrorMessage from "@components/ConditionalErrorMessage";
import { createSignal, type Accessor, type Setter } from "solid-js";

export const InvitationCodeModal = (props: {
  id: number;
  invitationCode: Accessor<string>;
  setInvitationCode: Setter<string>;
  modalOpen: Accessor<boolean>;
  setModalOpen: Setter<boolean>;
  onSuccess: () => void;
  onFailure?: () => void;
}) => {
  const [loading, setLoading] = createSignal(false);
  const [error, setError] = createSignal<string | null>(null);

  const checkInvitationCode = async () => {
    //check invitation code
    setError(null);
    setLoading(true);
    const res = await api.events
      .byId(props.id)
      .checkInvitationCode({ invitationCode: props.invitationCode() });

    // good, then open modal
    if (res) {
      props.onSuccess();
    } else {
      setError("Incorrect invitation code.");
    }
    setLoading(false);
  };

  const modalId = "invitation-code-modal";

  return (
    <>
      <input
        type="checkbox"
        id={modalId}
        checked={props.modalOpen()}
        class="modal-toggle"
      />
      <div class="modal modal-bottom sm:modal-middle">
        <div class="modal-box">
          <h3 class="font-semibold text-2xl text-primary">
            Enter Invitation Code
          </h3>

          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Invitation Code</span>
            </label>
            <input
              type="text"
              placeholder="Code"
              class="input h-12 pr-2 pl-4 flex-shrink border-[#d1d5db] rounded-md border-1"
              onInput={(e) => props.setInvitationCode(e.currentTarget.value)}
              value={props.invitationCode()}
              onKeyPress={(e) => {
                if (e.key === "Enter") checkInvitationCode();
              }}
            />
          </div>
          <ConditionalErrorMessage error={error()} />
          <div class="modal-action">
            <button
              onClick={() => props.setModalOpen(false)}
              class="btn btn-ghost"
              disabled={loading()}
            >
              Cancel
            </button>

            <button
              class="btn btn-primary"
              onClick={checkInvitationCode}
              disabled={loading()}
            >
              Check Code
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default InvitationCodeModal;
